import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import "../../../styles/staff-onboarding/shift-management.css";
import { commonPostPutApi } from "../../../redux/reducers/commonApiSlice";
import { showConfirmAlert } from "../../components-react/ReactAlert";
import moment from "moment-timezone";
import {
  convertTo12HourFormat,
  convertTo24HourFormat,
} from "../../common-data/Converts";

const TrainerShiftManagement = ({
  userInfoData,
  rowData,
  closeModal,
  callFunction,
  isModal,
  mainCallback,
}) => {
  const dispatch = useDispatch();

  const forminitials = {
    selectedMorningShiftStartTime: "",
    selectedMorningShiftEndTime: "",
    selectedEveningShiftStartTime: "",
    selectedEveningShiftEndTime: "",
  };
  const [formValues, setFormValues] = useState(forminitials);
  const [formErrors, setFormErrors] = useState({});

  const onChangeInput = (e) => {
    const { name, value } = e.target;

    setFormValues((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const validateForm = (values) => {
    const errors = {};

    const toMoment = (time) => {
      if (!time) return null;
      return moment.tz(
        `2023-01-01T${time}`,
        "YYYY-MM-DDTHH:mm",
        "Asia/Kolkata"
      );
    };

    const allEmpty =
      !values.selectedMorningShiftStartTime &&
      !values.selectedMorningShiftEndTime &&
      !values.selectedEveningShiftStartTime &&
      !values.selectedEveningShiftEndTime;

    if (allEmpty) {
      errors.selectedMorningShiftStartTime = "Select Atleast One Shift!";
      errors.selectedEveningShiftStartTime = "Select Atleast One Shift!";
      return errors;
    }

    const morningStart = values.selectedMorningShiftStartTime;
    const morningEnd = values.selectedMorningShiftEndTime;

    if ((morningStart && !morningEnd) || (!morningStart && morningEnd)) {
      if (!morningStart)
        errors.selectedMorningShiftStartTime =
          "Start Time is required if End Time is entered!";
      if (!morningEnd)
        errors.selectedMorningShiftEndTime =
          "End Time is required if Start Time is entered!";
    }
    if (morningStart && morningEnd) {
      const start = toMoment(morningStart);
      const end = toMoment(morningEnd);
      if (start.isSame(end)) {
        errors.selectedMorningShiftEndTime =
          "Start and End time cannot be the same!";
      } else if (start.isAfter(end)) {
        errors.selectedMorningShiftEndTime =
          "End Time must be after Start Time!";
      }
    }

    const eveningStart = values.selectedEveningShiftStartTime;
    const eveningEnd = values.selectedEveningShiftEndTime;

    if ((eveningStart && !eveningEnd) || (!eveningStart && eveningEnd)) {
      if (!eveningStart)
        errors.selectedEveningShiftStartTime =
          "Start Time is required if End Time is entered!";
      if (!eveningEnd)
        errors.selectedEveningShiftEndTime =
          "End Time is required if Start Time is entered!";
    }
    if (eveningStart && eveningEnd) {
      const start = toMoment(eveningStart);
      const end = toMoment(eveningEnd);
      if (start.isSame(end)) {
        errors.selectedEveningShiftEndTime =
          "Start and End time cannot be the same!";
      } else if (start.isAfter(end)) {
        errors.selectedEveningShiftEndTime =
          "End Time must be after Start Time!";
      }
    }

    if (morningStart && morningEnd && eveningStart && eveningEnd) {
      const mStart = toMoment(morningStart);
      const mEnd = toMoment(morningEnd);
      const eStart = toMoment(eveningStart);
      const eEnd = toMoment(eveningEnd);

      if (mEnd.isAfter(eStart) && mStart.isBefore(eEnd)) {
        errors.selectedMorningShiftEndTime = "Shifts cannot overlap!";
        errors.selectedEveningShiftStartTime = "Shifts cannot overlap!";
      }
    }

    return errors;
  };

  const handleSubmitForm = async (payload) => {
    const method = "POST";
    const endpoint = "/trainerShift/add";
    const token = userInfoData?.token || "";

    try {
      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        setFormValues(forminitials);
        closeModal();
        if (typeof mainCallback === "function") {
          mainCallback();
        }
        toast.success(
          result?.payload?.message || "Shift timing updated successfully!"
        );
      } else {
        const errorMessage = result?.payload?.message || result?.error?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    } catch (error) {
      console.error("Error making POST request:", error);
    }
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm(formValues);
    setFormErrors(errors);

    if (Object.keys(errors).length === 0) {
      const shift_details = [];
      if (
        formValues.selectedMorningShiftStartTime &&
        formValues.selectedMorningShiftEndTime
      ) {
        shift_details.push({
          shift_name: "Morning",
          start_time: formValues.selectedMorningShiftStartTime,
          end_time: formValues.selectedMorningShiftEndTime,
          status: "active",
        });
      }
      if (
        formValues.selectedEveningShiftStartTime &&
        formValues.selectedEveningShiftEndTime
      ) {
        shift_details.push({
          shift_name: "Evening",
          start_time: formValues.selectedEveningShiftStartTime,
          end_time: formValues.selectedEveningShiftEndTime,
          status: "active",
        });
      }

      const userData = {
        trainer_id: rowData?.staff_id || "",
        is_notify_owner: 0,
        shift_details,
      };

      const handleConfirm = async () => {
        handleSubmitForm(userData);
      };

      showConfirmAlert(
        handleConfirm,
        `Are you sure you want to update this shift?`,
        "No, Cancel",
        "Yes, Submit"
      );
    }
  };

  useEffect(() => {
    if (rowData?.shift_details && Array.isArray(rowData.shift_details)) {
      const validShifts = rowData.shift_details.filter(
        (shift) =>
          shift &&
          typeof shift === "object" &&
          shift.shift_start &&
          shift.shift_end &&
          shift.shift_start !== null &&
          shift.shift_start !== "null" &&
          shift.shift_end !== null &&
          shift.shift_end !== "null" &&
          shift.shift_start.trim() !== "" &&
          shift.shift_end.trim() !== ""
      );

      if (validShifts.length > 0) {
        const updatedFormValues = { ...forminitials };

        const isAMTime = (timeStr) => {
          const [hours] = timeStr.split(":").map(Number);
          return hours >= 0 && hours < 12; // 00:00 to 11:59 is AM
        };

        const sortedShifts = validShifts.sort((a, b) => {
          const timeA = a.shift_start.split(":").map(Number);
          const timeB = b.shift_start.split(":").map(Number);
          const minutesA = timeA[0] * 60 + timeA[1];
          const minutesB = timeB[0] * 60 + timeB[1];
          return minutesA - minutesB;
        });

        sortedShifts.forEach((shift) => {
          const startTime = convertTo24HourFormat(shift.shift_start);
          const endTime = convertTo24HourFormat(shift.shift_end);

          if (isAMTime(shift.shift_start)) {
            if (!updatedFormValues.selectedMorningShiftStartTime) {
              updatedFormValues.selectedMorningShiftStartTime = startTime;
              updatedFormValues.selectedMorningShiftEndTime = endTime;
            }
          } else {
            if (!updatedFormValues.selectedEveningShiftStartTime) {
              updatedFormValues.selectedEveningShiftStartTime = startTime;
              updatedFormValues.selectedEveningShiftEndTime = endTime;
            }
          }
        });

        if (sortedShifts.length === 2) {
          const firstShiftIsAM = isAMTime(sortedShifts[0].shift_start);
          const secondShiftIsAM = isAMTime(sortedShifts[1].shift_start);

          if (firstShiftIsAM === secondShiftIsAM) {
            updatedFormValues.selectedMorningShiftStartTime =
              convertTo24HourFormat(sortedShifts[0].shift_start);
            updatedFormValues.selectedMorningShiftEndTime =
              convertTo24HourFormat(sortedShifts[0].shift_end);
            updatedFormValues.selectedEveningShiftStartTime =
              convertTo24HourFormat(sortedShifts[1].shift_start);
            updatedFormValues.selectedEveningShiftEndTime =
              convertTo24HourFormat(sortedShifts[1].shift_end);
          }
        }

        setFormValues(updatedFormValues);
      }
    }
  }, []);

  console.log("formErrors=> ", formErrors);

  return (
    <div className="trainer-shift-management">
      <div className="shift-table">
        <div className="shift-table-header">
          <div className="shift-name">Shift Name</div>
          <div className="shift-time">Start Time</div>
          <div className="shift-time">End Time</div>
        </div>

        <div className="shift-table-row">
          <label htmlFor="morning-start" className="formInputLabel">
            Morning
          </label>

          <input
            type="time"
            placeholder="Enter Start Time"
            className={`formInput ${
              formErrors?.selectedMorningShiftStartTime ? "formError" : ""
            }`}
            name="selectedMorningShiftStartTime"
            value={formValues.selectedMorningShiftStartTime}
            onChange={onChangeInput}
          />

          <input
            type="time"
            placeholder="Enter End Time"
            className={`formInput ${
              formErrors?.selectedMorningShiftEndTime ? "formError" : ""
            }`}
            name="selectedMorningShiftEndTime"
            value={formValues.selectedMorningShiftEndTime}
            onChange={onChangeInput}
          />
        </div>
        <div className="shift-table-row">
          <label htmlFor="evening-shift" className="formInputLabel">
            Evening
          </label>

          <input
            type="time"
            placeholder="Enter Start Time"
            className={`formInput ${
              formErrors?.selectedEveningShiftStartTime ? "formError" : ""
            }`}
            name="selectedEveningShiftStartTime"
            value={formValues.selectedEveningShiftStartTime}
            onChange={onChangeInput}
          />

          <input
            type="time"
            placeholder="Enter End Time"
            className={`formInput ${
              formErrors?.selectedEveningShiftEndTime ? "formError" : ""
            }`}
            name="selectedEveningShiftEndTime"
            value={formValues.selectedEveningShiftEndTime}
            onChange={onChangeInput}
          />
        </div>
      </div>

      <div className="shift-actions">
        <button type="submit" className="update-btn" onClick={onSubmit}>
          Update Shift
        </button>
      </div>

      {isModal &&
        rowData?.shift_details &&
        Array.isArray(rowData.shift_details) &&
        rowData.shift_details.length > 0 && (
          <div className="current-shift-times span2">
            {(() => {
              try {
                const validShifts = rowData.shift_details.filter(
                  (shift) =>
                    shift &&
                    typeof shift === "object" &&
                    shift.shift_start &&
                    shift.shift_end &&
                    shift.shift_start !== null &&
                    shift.shift_end !== null &&
                    shift.shift_start.trim() !== "" &&
                    shift.shift_end.trim() !== ""
                );

                if (validShifts.length === 0) {
                  return null;
                }

                const sortedCurrentShifts = validShifts.sort((a, b) => {
                  const getTimeInMinutes = (timeStr) => {
                    if (!timeStr || typeof timeStr !== "string") return 0;
                    const [hours, minutes] = timeStr.split(":").map(Number);
                    return isNaN(hours) || isNaN(minutes)
                      ? 0
                      : hours * 60 + minutes;
                  };

                  const timeA = getTimeInMinutes(a.shift_start);
                  const timeB = getTimeInMinutes(b.shift_start);
                  return timeA - timeB;
                });

                return (
                  <div className="current-shift-timing">
                    <div className="current-shift-label">
                      Current Shift Timing:
                      {sortedCurrentShifts.length > 1 && (
                        <span className="shift-count">
                          ({sortedCurrentShifts.length} shifts)
                        </span>
                      )}
                    </div>
                    <div className="current-shift-times">
                      {sortedCurrentShifts.map((shift, index) => {
                        const startTime = convertTo12HourFormat(
                          shift?.shift_start
                        );
                        const endTime = convertTo12HourFormat(shift?.shift_end);

                        return (
                          <div key={index} className="shift-time-display">
                            <span className="shift-time-range">
                              {startTime} - {endTime}
                            </span>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                );
              } catch (error) {
                console.error("Error processing current shifts:", error);
                return null;
              }
            })()}
          </div>
        )}
    </div>
  );
};

export default TrainerShiftManagement;
